import { mockBasketRenewal } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedRenewal } from '../../models/checkout-completed-item/checkout-completed-renewal.interface';
import { CheckoutResponse } from '../../models/checkout/checkout-response.interface';
import { mockCheckoutCompletedRenewal } from '../checkout-completed-item/checkout-completed-renewal.mock';

export const mockCheckoutResponseRenewal: CheckoutResponse<CheckoutCompletedRenewal> =
  {
    completedItems: [mockCheckoutCompletedRenewal],
    basket: mockBasketRenewal,
  };
